export function convCSDate(dateString: string) {
    if (typeof dateString != "string") return console.error("Date needs to be string!")
    var date = new Date();
    try {
        date = new Date(dateString.substring(0, 19)); //Cutting off the timezone offset by taking only the first 19 characters
    }
    catch (e) {
        date = new Date(parseInt(dateString.replace(/[^0-9 +]/g, '')));
    }

    var year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    var month = new Intl.DateTimeFormat('en', { month: 'long' }).format(date);
    var day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date);

    return `${month} ${day}, ${year}`;
}

/**
 * Returns the value of a query string if available or false.
 * @param {any} queryString
 */
export function getQueryStringParam(queryString: string) {
    const queryStrings = window.location.search.replace("?", "").split("&").map(x => x.split("="));
    const results = queryStrings.find(x => x[0]?.toLowerCase() === queryString?.toLowerCase());
    if (results) return results[1];
    return false;
}

export function getPageNumber() {
    const pageParam = getQueryStringParam("p")
    if (!pageParam) {
        return 0;
    }

    const pageNumber = parseInt(pageParam);
    return isNaN(pageNumber)
        ? 0
        : pageNumber - 1;
}

export function isPaginationEnabled() {
    return window.veRelatedMedia.relatedMediaItems[0].isPaginationEnabled;
}

export const getCurrentCategory = () => {
    const currentCat = window.veRelatedMedia.relatedMediaItems[0].category
    if (!currentCat) return false;
    if (currentCat === "All") return false;
    return currentCat;
}

export const getLinkFormat = () => {
    let url = window.location.pathname;
    let params = new URLSearchParams(window.location.search);
    params.set("p", "{pageNum}");

    return decodeURIComponent(`${url}?${params.toString()}`);
}

export const getCurrentAuthor = () => window.veRelatedMedia.relatedMediaItems[0].author || false;


/**
 * Returns common SVGs used in the grid.
 * Case 1- blog, Case 2 - video, Case 3 - Webinar, Case 4 - Podcast
 * @param {any} name
 */
export const getSvg = (name: Number) => {
    switch (name) {
        case 1:
            return `<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="blog" class="svg-inline--fa fa-blog fa-w-16 fa-3x icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                                <path fill="currentColor" d="m 17.112303,7.9225352 -3.721739,4.1483138 -0.118625,1.133376 1.045882,-0.170256 3.70764,-4.1325758 z M 18.863762,7.4547443 18.376858,6.9901735 c -0.0817,-0.078021 -0.185238,-0.1261868 -0.271378,-0.1238269 -0.03333,-0.00163 -0.06589,0.010082 -0.09014,0.032414 l -0.599307,0.6181672 0.941184,0.9337764 0.612789,-0.6322986 c 0.06242,-0.064287 0.03017,-0.2334938 -0.106246,-0.3636613 z M 6.8352423,7.2114327 a 0.52816901,0.52816901 0 0 0 -0.5281691,0.528169 0.52816901,0.52816901 0 0 0 0.5281691,0.528169 h 7.7781137 a 0.52816901,0.52816901 0 0 0 0.528169,-0.528169 0.52816901,0.52816901 0 0 0 -0.528169,-0.528169 z m 0,3.5211263 a 0.52816901,0.52816901 0 0 0 -0.5281691,0.528169 0.52816901,0.52816901 0 0 0 0.5281691,0.528169 h 4.9612127 a 0.52816901,0.52816901 0 0 0 0.528169,-0.528169 0.52816901,0.52816901 0 0 0 -0.528169,-0.528169 z m 0,3.521127 a 0.52816901,0.52816901 0 0 0 -0.5281691,0.528169 0.52816901,0.52816901 0 0 0 0.5281691,0.528169 H 18.471466 a 0.52816901,0.52816901 0 0 0 0.528169,-0.528169 0.52816901,0.52816901 0 0 0 -0.528169,-0.528169 z m 0,3.521127 a 0.52816901,0.52816901 0 0 0 -0.5281691,0.528169 0.52816901,0.52816901 0 0 0 0.5281691,0.528169 H 18.471466 a 0.52816901,0.52816901 0 0 0 0.528169,-0.528169 0.52816901,0.52816901 0 0 0 -0.528169,-0.528169 z M 12.5,0 C 5.602697,0 0,5.602697 0,12.5 0,19.397303 5.602697,25 12.5,25 19.397303,25 25,19.397303 25,12.5 25,5.602697 19.397303,0 12.5,0 Z m 0,1.056338 c 6.326416,0 11.443662,5.117246 11.443662,11.443662 0,6.326416 -5.117246,11.443662 -11.443662,11.443662 C 6.173584,23.943662 1.056338,18.826416 1.056338,12.5 1.056338,6.173584 6.173584,1.056338 12.5,1.056338 Z">
                                </path>
                              </svg>`;
        case 2:
            return `<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="play-circle" class="svg-inline--fa fa-play-circle fa-w-16 fa-3x icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M 10.1525,7.6262504 C 9.4088471,7.6408774 8.7143741,8.2420884 8.715,9.0612499 V 14.9375 c -8.432e-4,1.092215 1.2338231,1.796302 2.17375,1.24 l 4.96875,-2.93875 c 0.923476,-0.546327 0.923476,-1.932423 0,-2.47875 L 10.88875,7.8212497 C 10.653768,7.6821749 10.400384,7.6213758 10.1525,7.6262504 Z M 9.9100002,8.6299998 C 10.048592,8.5509094 10.229738,8.5467295 10.4,8.6475003 l 4.96875,2.9387497 c 0.333052,0.197033 0.333052,0.629217 0,0.82625 L 10.4,15.351252 C 10.059477,15.552794 9.6746977,15.3332 9.675,14.937503 V 9.0612525 C 9.6748489,8.863405 9.7714074,8.7090934 9.9100002,8.6300024 Z M 12,0 C 5.37776,0 0,5.37776 0,12 0,18.62224 5.37776,24 12,24 18.62224,24 24,18.62224 24,12 24,5.37776 18.62224,0 12,0 Z m 0,0.96 C 18.10352,0.96 23.04,5.89648 23.04,12 23.04,18.10352 18.10352,23.04 12,23.04 5.89648,23.04 0.96,18.10352 0.96,12 0.96,5.89648 5.89648,0.96 12,0.96 Z">
                                </path>
                              </svg>`
        case 3:
            return `<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="webinar-circle" class="svg-inline--fa fa-webinar-circle fa-w-16 fa-3x icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.5 23.5">
                                <path fill="currentColor" d="M 12.000217,8.935 C 10.864438,8.935 9.935,9.8644377 9.935,11.000218 c 3e-7,1.13578 0.929438,2.065218 2.065217,2.065218 1.135779,0 2.065217,-0.929438 2.065217,-2.065218 0,-1.1357803 -0.929438,-2.0652181 -2.065217,-2.065218 z m -0.0213,1.065218 c 0.246244,0 0.49031,0.10086 0.695313,0.289063 0.400499,0.408895 0.394334,0.98771 0.01172,1.347656 -0.414629,0.389463 -1.029443,0.405216 -1.382814,0.03125 -0.388785,-0.414049 -0.407064,-1.02383 -0.0332,-1.375 0.206975,-0.194413 0.458712,-0.292969 0.708984,-0.292969 z M 10.900391 13.972656 C 9.3932093 13.972656 8.2597656 15.372808 8.2597656 17 L 9.7402344 17 C 9.7402344 16.029192 10.333572 15.455078 10.900391 15.455078 L 13.099609 15.455078 C 13.703906 15.455078 14.259766 16.079104 14.259766 17 L 15.740234 17 C 15.740234 15.428896 14.655313 13.972656 13.099609 13.972656 L 10.900391 13.972656 z M 6.1992188 6.5 C 5.4755755 6.5 4.9277344 7.1349285 4.9277344 7.8496094 L 4.9277344 16.150391 C 4.9277344 16.865071 5.4755755 17.5 6.1992188 17.5 L 17.654297 17.5 C 17.654945 17.5 17.655602 17.500001 17.65625 17.5 C 18.378933 17.498864 18.927734 16.86514 18.927734 16.150391 L 18.927734 7.8496094 C 18.927734 7.1342193 18.37794 6.5 17.654297 6.5 L 6.1992188 6.5 z M 6.1992188 7.5 L 17.654297 7.5 C 17.784654 7.5 17.927734 7.6249994 17.927734 7.8496094 L 17.927734 16.150391 C 17.927734 16.375001 17.784654 16.5 17.654297 16.5 L 6.1992188 16.5 C 6.068862 16.5 5.9277344 16.37571 5.9277344 16.150391 L 5.9277344 7.8496094 C 5.9277344 7.6242902 6.068862 7.5 6.1992188 7.5 z M 8 18.5 L 8 19.5 L 16 19.5 L 16 18.5 L 8 18.5 z  M 12,0.25 C 5.5195377,0.25 0.25,5.5195377 0.25,12 0.25,18.480462 5.5195377,23.75 12,23.75 18.480462,23.75 23.75,18.480462 23.75,12 23.75,5.5195377 18.480462,0.25 12,0.25 Z M 12,1.25 C 17.946378,1.25 22.75,6.0536221 22.75,12 22.75,17.946378 17.946378,22.75 12,22.75 6.0536221,22.75 1.25,17.946378 1.25,12 1.25,6.0536221 6.0536221,1.25 12,1.25 Z">
                                </path>
                              </svg>`;
        case 4:
            return `<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="microphone-circle" class="svg-inline--fa fa-microphone-circle fa-w-16 fa-3x icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <path fill="currentColor" d="m 6.595052,9.807292 a 0.5,0.5 0 0 0 -0.5,0.5 v 1.800781 c 0,3.078211 2.394846,5.53622 5.404948,5.803386 v 1.804687 H 8.2343747 a 0.5,0.5 0 0 0 -0.5,0.5 0.5,0.5 0 0 0 0.5,0.5 H 11.990885 12 15.765625 a 0.5,0.5 0 0 0 0.5,-0.5 0.5,0.5 0 0 0 -0.5,-0.5 H 12.5 v -1.804687 c 3.010102,-0.267166 5.404948,-2.725175 5.404948,-5.803386 v -1.800781 a 0.5,0.5 0 0 0 -0.5,-0.5 0.5,0.5 0 0 0 -0.5,0.5 v 1.800781 c 0,2.715063 -2.189885,4.904948 -4.904948,4.904948 -2.7150633,0 -4.904948,-2.189885 -4.904948,-4.904948 v -1.800781 a 0.5,0.5 0 0 0 -0.5,-0.5 z M 12,0 C 5.3785053,0 0,5.3785053 0,12 0,18.621495 5.3785053,24 12,24 18.621495,24 24,18.621495 24,12 24,5.3785053 18.621495,0 12,0 Z m 0,1 C 18.081055,1 23,5.9189453 23,12 23,18.081055 18.081055,23 12,23 5.9189453,23 1,18.081055 1,12 1,5.9189453 5.9189453,1 12,1 Z m 0.0063,13.331333 v 0 c -1.270255,0 -2.300001,-1.104364 -2.300001,-2.466666 V 6.9313327 c 0,-1.3623014 1.029746,-2.466666 2.300001,-2.466666 v 0 c 1.270253,0 2.299999,1.1043646 2.299999,2.466666 v 4.9333343 c 0,1.362302 -1.029746,2.466666 -2.299999,2.466666 z">
                                  </path>
                                </svg>`;
        default:
            return "";
    }
}

/**
 * Returns the appropriate media type based on enum
 * Case 1- blog, Case 2 - video, Case 3 - Webinar, Case 4 - Podcast
 * @param {any} name
 */
export const getRelatedMediaType = (name: Number) => {
    switch (name) {
        case 1:
            return "Blog";
        case 2:
            return "video";
        case 3:
            return "Webinar";
        case 4:
            return "Podcast";
        default:
            return "";
    }
}


export const getSiteContext = (name: string) => {
    switch (name) {
        case "Unknown":
            return 0;
        case "Us":
            return 1;
        case "Ucits":
            return 2;
        case "Corp":
            return 3;
        case "ForeignTax":
            return 4;
        case "Au":
            return 5;
        case "Etn":
            return 6;
        case "Latam":
            return 8;
        default:
            return 1;
    }
}

/**
 * Returns Gtm grid card attribute
 * Case 1- blog, Case 2 - video, Case 3 - Webinar, Case 4 - Podcast
 * @param {any} name
 */
export const getGtmGridCardAttributeValue = (name: Number) => {
    switch (name) {
        case 1:
            return "container-blog-post-item";
        case 2:
            return "container-video-item";
        case 3:
            return "container-webinar-item";
        case 4:
            return "container-podcast-item";
        default:
            return "";
    }
}

/**
 * Returns Gtm grid card attribute
 * Case 1- blog, Case 2 - video, Case 3 - Webinar, Case 4 - Podcast
 * @param {any} name
 */
export const getGtmAuthorAttributeValue = (name: Number) => {
    switch (name) {
        case 3:
            return "item-presenter";
        default:
            return "item-author";
    }
}